module.exports = __webpack_public_path__ + "static/img/banner_4.82c962b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_4.jpg
// module id = e2IV
// module chunks = 0